module.exports = __webpack_public_path__ + "static/media/event-services-img4.7392ed12.jpg";